import { NgModule } from 'ng-metadata/core';

import {PrmDepositsLink} from './depositsLink.directive';
import {AccountOverviewService} from '../overview/accountOverview.service';


@NgModule({
    declarations: [
        PrmDepositsLink
    ],
    providers: [
        AccountOverviewService
    ],
    imports: [
    ]
})
export class DepositsLinkModule {}


// WEBPACK FOOTER //
// ./src/main/webapp/components/account/depositsLink/depositsLink.module.ts